import { FirebaseError } from 'firebase/app';

/** Maps Firebase Auth error codes to pt-BR copy (CLAUDE.md: "copy do dashboard pt-BR único"). */
const MESSAGES: Record<string, string> = {
  'auth/email-already-in-use': 'Este e-mail já está cadastrado. Tente entrar em vez de criar uma conta.',
  'auth/invalid-email': 'E-mail inválido.',
  'auth/weak-password': 'Senha muito curta — use pelo menos 6 caracteres.',
  'auth/user-not-found': 'E-mail ou senha incorretos.',
  'auth/wrong-password': 'E-mail ou senha incorretos.',
  'auth/invalid-credential': 'E-mail ou senha incorretos.',
  'auth/too-many-requests': 'Muitas tentativas. Aguarde um momento e tente novamente.',
  'auth/popup-closed-by-user': 'Login cancelado.',
  'auth/network-request-failed': 'Falha de rede. Verifique sua conexão e tente novamente.',
};

export function mapFirebaseAuthError(error: unknown): string {
  if (error instanceof FirebaseError) {
    return MESSAGES[error.code] ?? 'Não foi possível concluir. Tente novamente.';
  }
  return 'Não foi possível concluir. Tente novamente.';
}
